import {BaseEffect} from './base.effect';
import {Injectable} from '@angular/core';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {Router} from '@angular/router';
import { select, Store} from '@ngrx/store';
import {debug} from '../../../rxjs-operators';
import {catchError, delayWhen, filter, map, switchMap,  withLatestFrom} from 'rxjs/operators';
import {error} from '..';
import {
  LoadPlayerConfigurationDefinitionFailAction,
  LoadPlayerConfigurationDefinitionSuccessAction,
  playerConfigurationDefinitionActionTypes
} from '../actions/player-configuration-definition';
import {PlayerConfigurationDefinition} from '../models/player-config-list-option';
import {PlayerConfigurationDefinitionService} from '../services/player-config-list.service';
import * as fromRoot from '../reducers';
import * as fromSite from '../../site/reducers';
import * as _ from 'lodash';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class PlayerConfigurationDefinitionEffect extends BaseEffect {

  private currentClient$ = this.storeRoot.pipe(select(fromRoot.selectors.getCurrentClient), filter(client => !_.isEmpty(client)));
  private site$ = this.storeSite.pipe(select(fromSite.selectors.getSite), filter(state => !_.isEmpty(state)));

  load$ = createEffect(() => { return this.actions$.pipe(
    ofType(playerConfigurationDefinitionActionTypes.LOAD),
    debug('Player config list load action received.'),
    delayWhen(() => this.currentClient$),
    delayWhen(() => this.site$),
    withLatestFrom(this.currentClient$, this.site$),
    switchMap(([data, client, site]) => this.playerConfigurationDefinitionService.getList(client.uuid, site.subscriptions[0].uuid).pipe(
      map((payload: SendBackResult<ArrayResponse<PlayerConfigurationDefinition>>) =>
        new LoadPlayerConfigurationDefinitionSuccessAction(this.addBooleanToDefinition(payload.data.array))),
      catchError(res => this.catchResponseError(res)),
    ))
  )});
  loadClient$ = createEffect(() => { return this.actions$.pipe(
    ofType(playerConfigurationDefinitionActionTypes.LOAD_CLIENT),
    debug('Player config list load action received.'),
    delayWhen(() => this.currentClient$),
    withLatestFrom(this.currentClient$),
    switchMap(([data, client]) => this.playerConfigurationDefinitionService.getListClient(client.uuid).pipe(
      map((payload: SendBackResult<ArrayResponse<PlayerConfigurationDefinition>>) =>
        new LoadPlayerConfigurationDefinitionSuccessAction(this.addBooleanToDefinition(payload.data.array))),
      catchError(res => this.catchResponseError(res)),
    ))
  )});

 /* loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(playerConfigurationDefinitionActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving Player config list.'),
    map((action: LoadPlayerConfigurationDefinitionFailAction) =>
      error(this.translation.translate('PLAYER_CONFIG_DEF_LIST_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE')))
  )});*/

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private storeSite: Store<fromSite.AppState>,
              private storeRoot: Store<fromRoot.AppState>,
              private playerConfigurationDefinitionService: PlayerConfigurationDefinitionService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadPlayerConfigurationDefinitionFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadPlayerConfigurationDefinitionFailAction(response['error'].message);
  }

  addBooleanToDefinition(definitions: PlayerConfigurationDefinition[]): PlayerConfigurationDefinition[] {
    return definitions.map(data => ({ ...data, isUsed: false }));
  }
}
